import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryGrid from './components/CategoryGrid';
import HotRanking from './components/HotRanking';
import FAQSection from './components/FAQSection';
import { stats } from '@/mocks/testimonials';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="国产精品视频精选推荐平台 - 汇聚海量国产精品视频，涵盖剧情、纪录、综艺、短片等多元类型"
        description="国产精品视频精选推荐平台，精心筛选高品质国产原创内容，为您提供流畅、清晰、优质的观看体验。覆盖剧情片、纪录片、综艺节目、创意短片等多元类型，发现更多国产精品视频，尽在本站。"
        keywords="国产精品视频,国产精品视频推荐,国产高清精品视频,国产原创精品视频,国产精品短视频,国产精品视频合集,国产精品视频在线观看"
        canonicalPath="/"
      />

      <Navbar />

      <main>
        <HeroSection />

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                      {stat.value}
                    </div>
                    <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <FeaturedVideos />
        <CategoryGrid />
        <HotRanking />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}